import React from 'react'
import { useStateValue } from '../state'
import { NavLink } from 'react-router-dom'

export const Nav = () => {
  let [currentState] = useStateValue()
  const activeStyle = {
    textDecoration: 'none',
    borderBottom: 'solid',
  }
  const styleDict = { textDecoration: 'none' }
  const classes = 'px-5 py-3 text-dark'
  return (
    <div style={{ marginBottom: '4em' }}>
      <NavLink
        exact
        to={`/account/admin_coupons.management/${currentState.coursenum}/`}
        activeStyle={activeStyle}
        style={styleDict}
        className={classes}
        isActive={() => !window.location.pathname.includes('/reports')}
      >
        Orders and Codes
      </NavLink>
      <NavLink
        exact
        to={`/account/admin_coupons.management/${currentState.coursenum}/reports/`}
        activeStyle={activeStyle}
        style={styleDict}
        className={classes}
      >
        Reports
      </NavLink>
    </div>
  )
}
